export default __webpack_public_path__ + "static/media/V420MANE1.afbc4d3d.pdf";